import {Component} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-upload-measurement-protocol',
  templateUrl: './upload-measurement-protocol.component.html',
  styleUrls: ['./upload-measurement-protocol.component.scss']
})
export class UploadMeasurementProtocolComponent {
  selectedFiles: FileList;

  constructor(private dialogRef: MatDialogRef<UploadMeasurementProtocolComponent>) {
  }

  onFilesChanged(files: FileList) {
    this.selectedFiles = files;
  }

  save() {
    this.dialogRef.close(this.selectedFiles);
  }

  dismiss() {
    this.dialogRef.close();
  }
}
